/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import classnames from "classnames";
import styles from "./TimelineBlock.module.scss";

export interface TimeliveBlockProps {
  entries: [
    {
      header: string;
      content: string;
    },
  ];
}

export const TimelineBlock: React.FC<TimeliveBlockProps> = (props: TimeliveBlockProps) => {
  const { entries } = props;

  return (
    <div className={styles.root}>
      <div className={styles.scrollContainer}>
        <div className={styles.entriesContainer}>
          {entries.map((entry, index) => (
            <div className={styles.entryContainer} key="key-${index}">
              <div className={styles.lineContainer}>
                <div className={styles.bigDot}></div>
                <div className={styles.line}></div>
                <div className={styles.smallDot}></div>
              </div>
              <div className={styles.contentContainer}>
                <div className={styles.header}>
                  <h2>{entry.header}</h2>
                </div>
                <div className={styles.text}>{entry.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
